import { makeObservable, observable, reaction } from "mobx";
import TaskPackageAnalysis from "./TaskPackageAnalysis";
import NBaseline from "./NBaseline";

export default class ProjectAnalysis {
  id = "";
  name = "";
  folderName = "";
  ownerName = "";
  baselines = [];
  currentHash = "";
  rootTaskPackage = {};

  constructor() {
    makeObservable(this, {
      name: observable,
      baselines: observable,
      rootTaskPackage: observable,
    })
  }

  saveProjectDisposer = reaction(
    () => {
      return this.toJS();
    },
    (data) => {
      // localStorage.setItem('sma_eva_analysis_state_mobx', JSON.stringify(data));
    },
    { delay: 5000 }
  );

  updateRankingsDisposer = reaction(
    () => {
      return {
        //slight overkill to establish observation on every property (e.g., description doesn't matter)
      };
    },
    (data) => { },
    { delay: 750 }
  ); //debounce typing into name/description etc fields

  dispose() {
    this.saveProjectDisposer();
  }

  toJS() {
    let plainObject = {};
    plainObject.id = this.id;
    plainObject.name = this.name;
    plainObject.currentHash = this.currentHash;
    plainObject.ownerName = this.ownerName;
    plainObject.folderName = this.folderName;
    plainObject.baselines = this.baselines.map((baseline) => baseline.toJS());
    plainObject.rootTaskPackage =
      this.rootTaskPackage.toJS != null ? this.rootTaskPackage.toJS() : null;
    return plainObject;
  }

  static fromJS(savedState) {
    const projectStore = new ProjectAnalysis();
    if (savedState != null) {
      projectStore.id = savedState.id;
      projectStore.name = savedState.name;
      projectStore.currentHash = savedState.currentHash;
      projectStore.ownerName = savedState.ownerName;
      projectStore.folderName = savedState.folderName;
      projectStore.baselines =
        savedState.baselines === undefined || savedState.baselines == null
          ? []
          : savedState.baselines.map((baseline) => NBaseline.fromJS(baseline));
      projectStore.rootTaskPackage = TaskPackageAnalysis.fromJS(
        projectStore,
        savedState.rootTaskPackage
      );
    }
    return projectStore;
  }

  static fromJS_ToArray(savedState, specifiedPeriod) {
    const projectStore = new ProjectAnalysis();
    let evaData = [];
    let evaStyle = [];
    let depth = 0;
    if (savedState != null) {
      projectStore.id = savedState.id;
      projectStore.name = savedState.name;
      projectStore.currentHash = savedState.currentHash;
      projectStore.ownerName = savedState.ownerName;
      projectStore.folderName = savedState.folderName;
      projectStore.baselines =
        savedState.baselines === undefined || savedState.baselines == null
          ? []
          : savedState.baselines.map((baseline) => NBaseline.fromJS(baseline));

      const rootTaskPackage = TaskPackageAnalysis.fromJS(projectStore, savedState.rootTaskPackage);
      const resultRows = rootTaskPackage.buildReportRows(0, specifiedPeriod);
      
      for (let i = 0; i < resultRows.length; i++) {
        const row = resultRows[i];
        row.directChildIndices = [];
        for (const childId of row.directChildren) {
          row.directChildIndices.push(resultRows.findIndex(e => e.id === childId));
        }
        if (row.directChildIndices.length > 0) {
          let facFormula = "=SUM(";
          let acFormula = "=SUM(";
          for (const index of row.directChildIndices) {
            const rowNum = index + 5
            facFormula += "J" + rowNum + ",";
            acFormula += "F" + rowNum + ",";
          }
          facFormula += ")";
          acFormula += ")";
          row.fac = facFormula;
          row.actualCost = acFormula;
        }
        row.vac = "=E" + (i + 5) + "-" + "J" + (i + 5);
      }

      return resultRows;
    }
    return [];
    /*let data = TaskPackageAnalysis.fromJS_To2DArray(
      projectStore,
      rootTaskPackage,
      evaData,
      specifiedPeriod
    );
    let style = TaskPackageAnalysis.fromJS_DetermineStyle(
      projectStore,
      savedState.rootTaskPackage,
      evaStyle,
      depth
    );
    data.evaData.sort((a,b) => a.sortIndex - b.sortIndex);
    style.evaStyle.sort((a,b) => a.sortIndex - b.sortIndex);
    for (let i = 0; i < style.evaStyle.length; i++) {
      const rowDepth = style.evaStyle[i].depth;
      data.evaData[i].displayName = " ".repeat(2*rowDepth) + data.evaData[i].displayName;
    }
    alert(JSON.stringify(data.evaData));
    return { data: data.evaData, style: style.evaStyle };
  }
  return { data: evaData, style: evaStyle };*/
  }


}
